/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../adpIntegration/adpIntegration.controller.ts" />

module Meevo.Plugins.AdpRunIntegration {
    class AdpRunIntegrationController extends Meevo.Plugins.AdpIntegration.AdpIntegrationController {

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.AdpIntegrationService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected $translate: angular.translate.ITranslateService,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService        ) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityService,
                trackingService,
                $rootScope,
                $scope,
                $state,
                contextParams,
                shortCutsService,
                busyService
            );
        }


        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.INTEGRATION_ADPINTEGRATION).then(() => {
                vm.busyService.stop();
                vm.context = new AdpRunIntegrationContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, vm.securityService, vm.trackingService, vm.busyService, vm.$rootScope, vm.$translate, vm.contextParams);

                super.createContext();
            });
        }

    }
    angular.module("meevo.plugins.adpIntegration")
        .controller("meevo.plugins.adpRunIntegration.adpRunIntegrationController", AdpRunIntegrationController);
}

